import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import { AlertMsg, AlertError, AlertLoading } from '../helpers/AlertHelper'
import { Save2 } from 'react-bootstrap-icons'
import ConfigService from '../services/ConfigService'

const Config = () => {

    const [title, setTitle] = useState('')
    const [formValid, setFormValid] = useState(false)
    const [showMsg, setShowMsg] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(false)

    const getData = async () => {
        await ConfigService.getConfig().then(
            response => {
                setTitle(response.data.title || '')
                setIsLoaded(true)
            },
            error => {
                setError(error)
            })
    }

    useEffect(() => {

        getData()

    }, [])

    const handleInputChange = (e) => {
        const fieldName = e.target.name
        const value = e.target.value
        setFieldValue(fieldName, value)
    }

    const setFieldValue = (fieldName, value) => {
        switch (fieldName) {
            case 'appTitle':
                document.title = value
                setTitle(value)
                break
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        e.stopPropagation()

        const form = e.currentTarget
        if (!form.checkValidity()) {
            setFormValid(true)
            return
        }

        const config = {
            title
        }

        try {
            
            await ConfigService.updateConfig(config)

            setFormValid(false)

        } catch (error) {
            setShowMsg({ text: error || "An error occurred", style: 'danger' })
            setShowAlert(true)
        } finally {
            setFormValid(true)
        }
    }

    if (error) {
        return (
            <AlertError error={error} />
        )
    } else if (!isLoaded) {
        return (
            <AlertLoading isLoaded={isLoaded} />
        )
    }

    return (
        <Container className="p-5">
            <Form noValidate validated={formValid} onSubmit={handleSubmit}>

                <Form.Group className="mb-3" controlId="appTitle">
                    <Form.Label>APP Title:</Form.Label>
                    <Form.Control
                        type="text"
                        name="appTitle"
                        value={title}
                        placeholder='App title'
                        onChange={handleInputChange}
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        Provide a title for your APP
                    </Form.Control.Feedback>
                </Form.Group>


                <AlertMsg message={showMsg.text} variant={showMsg.style} dismissible onCloseHandler={() => setShowAlert(false)} show={showAlert} />

                <div className="d-grid gap-2">

                    <Button
                        className="btn btn-primary"
                        type="submit"
                    >
                        <Save2 /> <FormattedMessage id="textSave" defaultMessage="Save" />
                    </Button>

                </div>
            </Form>
        </Container>
    )

}

export default Config
